
import { Airstrip, AircraftType, AdminSettings, Customer, Quote, Role, UserAccount, Booking, ProductMode, Leg, PermissionSet } from './types';

export const INITIAL_AIRCRAFT: AircraftType[] = [
  { 
    id: 'C208-1', 
    name: 'Cessna Grand Caravan', 
    tailNumber: '5H-SRG', 
    hourlyRate: 1250, 
    minBillableHours: 1.0, 
    operatingCostPerHour: 680, 
    maxPax: 12, 
    crewCount: 2, 
    fuelBurnLitersPerHour: 180,
    status: 'SERVICEABLE',
    hoursToService: 42,
    totalAirframeHours: 4250,
    totalBlockHours: 3800,
    totalDutyHours: 4100,
    lastLandedLocation: 'ARK',
    imageUrl: 'https://images.unsplash.com/photo-1569154941061-e231b4725ef1?auto=format&fit=crop&q=80&w=400',
    fuelStatus: { leftWing: 450, rightWing: 450, lastUpdated: '2026-01-11T18:00:00Z' },
    fuelHistory: [],
    telemetry: { lat: -3.367, lng: 36.633, altitude: 0, groundSpeed: 0, heading: 90, lastUpdate: new Date().toISOString() }
  },
  { 
    id: 'C208-2', 
    name: 'Cessna Grand Caravan (VIP)', 
    tailNumber: '5H-AZH', 
    hourlyRate: 1350, 
    minBillableHours: 1.0, 
    operatingCostPerHour: 700, 
    maxPax: 11, 
    crewCount: 3, 
    fuelBurnLitersPerHour: 185,
    status: 'SERVICEABLE',
    hoursToService: 12,
    totalAirframeHours: 1120,
    totalBlockHours: 1050,
    totalDutyHours: 1090,
    lastLandedLocation: 'SEU',
    imageUrl: 'https://images.unsplash.com/photo-1583000292278-59527042303e?auto=format&fit=crop&q=80&w=400',
    fuelStatus: { leftWing: 120, rightWing: 120, lastUpdated: '2026-01-11T19:30:00Z' },
    fuelHistory: [],
    telemetry: { lat: -2.333, lng: 34.816, altitude: 0, groundSpeed: 0, heading: 270, lastUpdate: new Date().toISOString() }
  },
  { 
    id: 'PC12', 
    name: 'Pilatus PC-12', 
    tailNumber: '5H-MAA', 
    hourlyRate: 1850, 
    minBillableHours: 1.2, 
    operatingCostPerHour: 950, 
    maxPax: 8, 
    crewCount: 2, 
    fuelBurnLitersPerHour: 240,
    status: 'SERVICEABLE',
    hoursToService: 88,
    totalAirframeHours: 2100,
    totalBlockHours: 1950,
    totalDutyHours: 2020,
    lastLandedLocation: 'ZNZ',
    imageUrl: 'https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=400',
    fuelStatus: { leftWing: 600, rightWing: 600, lastUpdated: '2026-01-11T17:00:00Z' },
    fuelHistory: [],
    telemetry: { lat: -6.222, lng: 39.225, altitude: 0, groundSpeed: 0, heading: 180, lastUpdate: new Date().toISOString() }
  }
];

export const INITIAL_USERS: UserAccount[] = [
  { id: 'USR-001', name: 'Capt. Gasper M.', role: 'ADMIN', lastLogin: '2025-12-27T14:30:00Z', status: 'ACTIVE', licenseExpiry: '2027-05-12', totalFlightHours: 8500, currentLocation: 'ARK', dutyHoursToday: 4.5, maxDutyHours: 12 },
  { id: 'PILOT-1', name: 'Capt. Sarah L.', role: 'CP', lastLogin: '2026-01-10T08:30:00Z', status: 'ACTIVE', licenseExpiry: '2026-11-20', totalFlightHours: 4200, currentLocation: 'ARK', dutyHoursToday: 0, maxDutyHours: 12 },
  { id: 'PILOT-2', name: 'First Officer Peter K.', role: 'CP', lastLogin: '2026-01-11T12:00:00Z', status: 'ACTIVE', licenseExpiry: '2026-09-05', totalFlightHours: 1100, currentLocation: 'SEU', dutyHoursToday: 7.8, maxDutyHours: 12 },
  { id: 'PILOT-3', name: 'Capt. Ahmed J.', role: 'CP', lastLogin: '2026-01-11T14:00:00Z', status: 'ACTIVE', licenseExpiry: '2027-01-30', totalFlightHours: 6700, currentLocation: 'ZNZ', dutyHoursToday: 11.2, maxDutyHours: 12 },
  { id: 'PILOT-4', name: 'First Officer Joyce T.', role: 'CP', lastLogin: '2026-01-11T16:00:00Z', status: 'ACTIVE', licenseExpiry: '2026-12-15', totalFlightHours: 1500, currentLocation: 'ARK', dutyHoursToday: 2.1, maxDutyHours: 12 },
];

export const INITIAL_AIRSTRIPS: Airstrip[] = [
  { code: 'ARK', name: 'Arusha Municipal', latitude: -3.367, longitude: 36.633, landingFee: 55, handlingFee: 110, internationalHandlingFee: 110, navigationFee: 35, paxTax: 15, fuelAvailable: true, country: 'Tanzania', meetAndAssistFee: 25, loungeFee: 45 },
  { code: 'SEU', name: 'Seronera', latitude: -2.333, longitude: 34.816, landingFee: 95, handlingFee: 135, internationalHandlingFee: 135, navigationFee: 45, paxTax: 25, fuelAvailable: false, country: 'Tanzania', meetAndAssistFee: 15, loungeFee: 0 },
  { code: 'ZNZ', name: 'Zanzibar', latitude: -6.222, longitude: 39.225, landingFee: 110, handlingFee: 160, internationalHandlingFee: 160, navigationFee: 55, paxTax: 35, arrivalTax: 10, fuelAvailable: true, country: 'Tanzania', isBorderPost: true, meetAndAssistFee: 50, loungeFee: 75 },
  { code: 'MWB', name: 'Mwiba', latitude: -3.4, longitude: 34.8, landingFee: 120, handlingFee: 150, internationalHandlingFee: 150, navigationFee: 60, paxTax: 20, fuelAvailable: false, country: 'Tanzania', meetAndAssistFee: 30, loungeFee: 0 },
  { code: 'MANYARA', name: 'Lake Manyara', latitude: -3.37, longitude: 35.81, landingFee: 45, handlingFee: 80, internationalHandlingFee: 80, navigationFee: 25, paxTax: 10, fuelAvailable: false, country: 'Tanzania', meetAndAssistFee: 10, loungeFee: 0 },
  { code: 'KOGATENDE', name: 'Kogatende', latitude: -1.58, longitude: 34.87, landingFee: 95, handlingFee: 140, internationalHandlingFee: 140, navigationFee: 45, paxTax: 30, fuelAvailable: false, country: 'Tanzania', meetAndAssistFee: 20, loungeFee: 0 },
];

const FULL_ACCESS: PermissionSet = { view: true, create: true, edit: true, delete: true, approve: true };
const ALL_ROLES: Role[] = ['RESERVATIONS', 'FLIGHT_PLANNER', 'DFO', 'CP', 'PILOT', 'FIRST_OFFICER', 'ACCOUNTS', 'CEO', 'ADMIN', 'GROUND_OPS'];

// Added missing STRATEGY permission to RolePermissions for each role to fix missing property errors.
export const INITIAL_SETTINGS: AdminSettings = {
  billingTimeBasis: 'BLOCK_TIME',
  returnBaseAirstrip: 'ARK',
  waitFreeMinutes: 60,
  waitRatePerHour: 175,
  waitRoundingMinutes: 30,
  waitEscalationHours: 4,
  sleepOverPolicy: {
    tier1Price: 250,
    tier2Price: 450,
  },
  routeDefaults: {
    cruiseSpeedKts: 120,
    ratePerNmUSD: 0,
    ratePerHourUSD: 0,
    distanceComputationModel: 'GEODESIC',
    distanceBufferPercent: 0,
    distanceBaseMiles: 0,
    roundDistanceUp: false,
    blockTimeMultiplier: 1,
    blockTimeBaseMinutes: 0,
    blockTimeRoundingMinutes: 1,
  },
  reservationCodes: {
    charter: {
      enabled: true,
      prefix: 'CH',
      nextNumber: 1,
      padding: 5,
    },
    scheduled: {
      enabled: true,
      prefix: 'SC',
      nextNumber: 1,
      padding: 5,
    },
    booking: {
      enabled: true,
      prefix: 'BK',
      nextNumber: 1,
      padding: 6,
    },
  },
  cancellationPolicies: {
    charter: {
      freeCancelHours: 24,
      enableCancelFee24h: true,
      cancelFee24hPercent: 50,
      enableCancelFee6h: true,
      cancelFee6hPercent: 100,
      enableNoShowFee: true,
      noShowFeePercent: 100,
      enableAmendmentFee: true,
      amendmentFeePercent: 10,
      enableNameChangeFee: true,
      nameChangeFeePercent: 10,
    },
    scheduled: {
      freeCancelHours: 12,
      enableCancelFee24h: true,
      cancelFee24hPercent: 25,
      enableCancelFee6h: true,
      cancelFee6hPercent: 75,
      enableNoShowFee: true,
      noShowFeePercent: 100,
      enableAmendmentFee: true,
      amendmentFeePercent: 10,
      enableNameChangeFee: true,
      nameChangeFeePercent: 10,
    },
  },
  fxRateUSD_TZS: 2650,
  defaultCurrency: 'USD',
  discountCapsByRole: {
    RESERVATIONS: 5, FLIGHT_PLANNER: 0, DFO: 10, CP: 0, PILOT: 0, FIRST_OFFICER: 0, ACCOUNTS: 0, CEO: 100, ADMIN: 100, GROUND_OPS: 0
  },
  agent: {
    enabled: false,
    advisoryOnly: true,
    advisoryMode: 'PANEL',
    provider: {
      type: 'GEMINI',
      apiKey: '',
      baseUrl: '',
      model: 'gemini-1.5-pro',
    },
    providerConnections: [
      {
        id: 'primary',
        label: 'Primary Provider',
        enabled: true,
        type: 'GEMINI',
        apiKey: '',
        baseUrl: '',
        model: 'gemini-1.5-pro',
      },
    ],
    taskRouting: {
      DRAFT_ASSIST: { connectionId: 'primary' },
      THREAD_SUMMARY: { connectionId: 'primary' },
      VOICE_TRANSCRIPT: { connectionId: 'primary' },
      DOCUMENT_EXTRACTION: { connectionId: 'primary' },
      CLASSIFICATION: { connectionId: 'primary' },
    },
    usage: {
      connections: {},
    },
    modules: {
      QUOTER: true,
      SCHEDULED: true,
      PLANNER: true,
      FUEL: true,
      WHATSAPP: true,
      EMAIL: true,
    },
    rolesByModule: {
      QUOTER: ALL_ROLES,
      SCHEDULED: ALL_ROLES,
      PLANNER: ALL_ROLES,
      FUEL: ALL_ROLES,
      WHATSAPP: ALL_ROLES,
      EMAIL: ALL_ROLES,
    },
    enforcement: {
      blockSeverities: ['HIGH'],
      allowOverride: true,
      requireOverrideReason: true,
      overrideRoles: ['ADMIN', 'DFO'],
    },
    enforcementByModule: {},
    ruleToggles: {},
    customRulesByModule: {},
    knowledgeBaseNotesByModule: {},
    guidance: {
      includeChecklist: true,
      includePolicyRefs: true,
      knowledgeBaseNotes: '',
    },
    communications: {
      whatsapp: {
        enabled: true,
        draftGuardian: {
          enabled: true,
          mode: 'WARN',
          blockSeverities: ['HIGH'],
          requireProfessionalTone: true,
          suggestRewrite: true,
          preferredPhrases: [
            'Kindly allow us to check and revert to you shortly.',
            'Thank you for your patience.',
            'We will confirm and get back to you shortly.',
          ],
          forbiddenPhrases: [
            'let me check',
            'wait',
            'i dont know',
            'not sure',
          ],
        },
        contextAssistant: {
          enabled: true,
          suggestActions: true,
          allowEstimateLookup: true,
          allowQuoteLookup: true,
          allowCustomerHistoryLookup: true,
        },
        intelligence: {
          enabled: true,
          generateSummary: true,
          extractTasks: true,
          extractReferences: true,
        },
        replyWatcher: {
          enabled: true,
          detectMissedReplies: true,
          detectBrokenPromises: true,
          reminderMinutes: 15,
        },
      },
      email: {
        enabled: false,
        includeQuotedHistory: true,
        draftGuardian: {
          enabled: false,
          mode: 'ASSIST',
          blockSeverities: ['HIGH'],
          requireProfessionalTone: true,
          suggestRewrite: true,
          preferredPhrases: [],
          forbiddenPhrases: [],
        },
        contextAssistant: {
          enabled: false,
          suggestActions: true,
          allowEstimateLookup: true,
          allowQuoteLookup: true,
          allowCustomerHistoryLookup: true,
        },
        intelligence: {
          enabled: false,
          generateSummary: true,
          extractTasks: true,
          extractReferences: true,
        },
        replyWatcher: {
          enabled: false,
          detectMissedReplies: true,
          detectBrokenPromises: true,
          reminderMinutes: 30,
        },
        replyIntelligence: {
          templates: [],
        },
      },
    },
  },
  permissions: {
    ADMIN: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: FULL_ACCESS, OUTBOUND: FULL_ACCESS, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: FULL_ACCESS },
    CEO: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: { view: false, create: false, edit: false, delete: false, approve: false }, OUTBOUND: { view: false, create: false, edit: false, delete: false, approve: false }, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: FULL_ACCESS },
    DFO: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: { view: false, create: false, edit: false, delete: false, approve: false }, OUTBOUND: { view: false, create: false, edit: false, delete: false, approve: false }, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: { view: false, create: false, edit: false, delete: false, approve: false } },
    FLIGHT_PLANNER: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: { view: false, create: false, edit: false, delete: false, approve: false }, OUTBOUND: { view: false, create: false, edit: false, delete: false, approve: false }, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: { view: false, create: false, edit: false, delete: false, approve: false } },
    RESERVATIONS: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: { view: false, create: false, edit: false, delete: false, approve: false }, OUTBOUND: { view: false, create: false, edit: false, delete: false, approve: false }, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: { view: false, create: false, edit: false, delete: false, approve: false } },
    GROUND_OPS: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: { view: false, create: false, edit: false, delete: false, approve: false }, OUTBOUND: { view: false, create: false, edit: false, delete: false, approve: false }, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: { view: false, create: false, edit: false, delete: false, approve: false } },
    CP: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: { view: false, create: false, edit: false, delete: false, approve: false }, OUTBOUND: { view: false, create: false, edit: false, delete: false, approve: false }, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: { view: false, create: false, edit: false, delete: false, approve: false } },
    ACCOUNTS: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: { view: false, create: false, edit: false, delete: false, approve: false }, OUTBOUND: { view: false, create: false, edit: false, delete: false, approve: false }, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: { view: false, create: false, edit: false, delete: false, approve: false } },
    PILOT: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: { view: false, create: false, edit: false, delete: false, approve: false }, OUTBOUND: { view: false, create: false, edit: false, delete: false, approve: false }, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: { view: false, create: false, edit: false, delete: false, approve: false } },
    FIRST_OFFICER: { DASHBOARD: FULL_ACCESS, OPERATIONS_TV: FULL_ACCESS, QUOTER: FULL_ACCESS, SCHEDULED: FULL_ACCESS, PLANNER: FULL_ACCESS, FRMS: FULL_ACCESS, FLEET: FULL_ACCESS, FUEL: FULL_ACCESS, CUSTOMERS: FULL_ACCESS, FINANCE: FULL_ACCESS, ADMIN: FULL_ACCESS, ADMIN_TOOLS: { view: false, create: false, edit: false, delete: false, approve: false }, OUTBOUND: { view: false, create: false, edit: false, delete: false, approve: false }, USERS: FULL_ACCESS, PILOTS: FULL_ACCESS, AUDIT: FULL_ACCESS, STRATEGY: FULL_ACCESS, COMMS: { view: false, create: false, edit: false, delete: false, approve: false } },
  },
  outbound: {
    email: {
      accounts: [],
      defaultAccountId: undefined,
      defaultAccountByUsage: {},
    },
  },
  sPhone: {
    enabled: false,
    wsServer: '',
    domain: '',
    autoRegister: true,
    defaultOutboundPrefix: '',
    iceServers: ['stun:stun.l.google.com:19302'],
    accounts: [],
  },
  backup: {
    enabled: false,
    cron: '0 2 * * *',
    localPath: '/home/blink/MEOS/backups',
    remotePath: '',
    retentionDays: 7,
    encrypt: false,
    encryptionPassphrase: '',
    allowRestore: false,
  },
  whatsappTransfer: {
    enabled: true,
    popupEnabled: true,
    autoIntroEnabled: true,
    allowOperatorOverride: true,
    autoIntroTemplate: "Hi, I'm taking over your request now. I will assist you from here.",
    returnToOwnerTemplate: "Welcome back {{clientName}}, I am now back on your chat and will continue assisting you.",
    askFeedbackBeforeReturn: false,
    feedbackPromptTemplate: "Before I return you to my colleague, was this support helpful? (Yes/No)",
  },
  whatsappRecall: {
    enabled: true,
    maxRecallMinutes: 120,
    allowLeadershipOverride: true,
    requireReason: false,
    allowMediaRecall: true,
  },
  loginPage: {
    banners: [],
    footer: {
      visible: true,
      leftText: 'Miracle Air — Aviation Intelligence',
      rightText: 'Secure access · Enterprise node',
      imageUrl: '',
      imageHeightPx: 140,
      animated: false,
    },
  },
  emailSystem: {
    inboundBridge: {
      enabled: false,
      ingestSecret: '',
      mailboxAddress: 'fly@miracleair.tz',
      allowEnvFallback: true,
      automation: {
        enabled: true,
        autoBackfillOnRecovery: true,
        staleAfterMinutes: 120,
        deadAfterMinutes: 360,
        autoBackfillCooldownMinutes: 30,
      },
    },
    outboundBridge: {
      enabled: false,
      provider: 'H.BRD_GMAIL',
      webhookUrl: '',
      authHeaderName: 'x-bridge-secret',
      authHeaderValue: '',
      timeoutMs: 15000,
      allowSmtpFallback: true,
    },
    intake: {
      enabled: true,
      defaultInboxKey: 'fly',
      hideNonFlightByDefault: true,
      hideSpamByDefault: true,
      blockedDomains: [],
      allowlistDomains: [],
      allowlistEmails: [],
      spamSubjectPatterns: [
        'newsletter',
        'unsubscribe',
        'promo',
        'promotion',
        'discount',
        'sale',
        'offer',
        'webinar',
        'free trial',
      ],
      alerts: {
        enabled: true,
        businessHoursOnly: false,
        firstResponseSlaMinutes: 15,
        escalationSteps: [
          {
            afterMinutes: 45,
            notifyRoles: ['DFO'],
            notifyEmails: [],
            channel: 'BOTH',
          },
          {
            afterMinutes: 90,
            notifyRoles: ['ADMIN', 'CEO'],
            notifyEmails: [],
            channel: 'BOTH',
          },
        ],
        autoResolveOnFirstOutbound: true,
      },
      automation: {
        enabled: true,
        replyOnFirstInboundOnly: true,
        applyToCategories: ['CHARTER', 'SCHEDULED', 'UNCERTAIN'],
        mailboxKeys: [],
        cooldownMinutes: 60,
        askMissingFields: true,
        subjectTemplate: 'Re: {{subject}}',
        bodyTemplate:
          'Hello {{customerName}},\n\nThank you for your request. Our operations team has received it and is preparing your quote.\n\n{{missingQuestions}}\n\nBest regards,\nME-OS Reservations',
        fallbackQuestions: [
          'Please confirm exact travel date (DD MMM YYYY).',
          'Please confirm preferred departure time.',
          'Please confirm passenger count (PAX).',
          'Please confirm full route (from and to airstrip).',
        ],
      },
    },
  },
  scheduledSop: {
    enabled: true,
    operatorCanDecline: false,
    requireCommandApprovalForDecline: true,
    declineRoles: ['DFO', 'ADMIN', 'CEO'],
    commandChainRoles: ['RESERVATIONS', 'DFO', 'ADMIN'],
    targetResponseMinutes: 15,
    initialResponseTemplate:
      'Thank you for your request. We are checking scheduled/empty-leg availability and will confirm options shortly.',
    pendingApprovalTemplate:
      'Your request is in command review for schedule release. We will update you within the stated response window.',
  },
};

export const INITIAL_CUSTOMERS: Customer[] = [
  { id: 'CUST-001', name: 'Serengeti Safaris', legalName: 'Serengeti Safaris Ltd', charterDiscount: 10, scheduleDiscount: 5, creditLimit: 50000, outstandingBalance: 12500, status: 'ACTIVE', source: 'ZOHO', totalQuotesSent: 45, totalRevenue: 85000 },
  { id: 'CUST-002', name: 'Coastal Travels', legalName: 'Coastal Travels Tanzania', charterDiscount: 5, scheduleDiscount: 0, creditLimit: 25000, outstandingBalance: 2000, status: 'ACTIVE', source: 'LOCAL', totalQuotesSent: 12, totalRevenue: 15000 }
];

export const MOCK_QUOTES: Quote[] = [
  {
    id: 'Q-2026-001',
    customerId: 'CUST-001',
    customerName: 'Serengeti Safaris',
    date: '2026-01-12',
    productMode: 'CHARTER',
    aircraftId: 'C208-1',
    tailNumber: '5H-SRG',
    legs: [
      { id: 'L1', from: 'ARK', to: 'SEU', paxPick: 4, paxOB: 4, paxDrop: 0, paxCount: 4, isDeadLeg: false, distance: 180, blockTimeMinutes: 55, etd: '08:00', eta: '08:55', tacticalStatus: 'OPEN', assignedCrew: ['PILOT-1', 'PILOT-4'] }
    ],
    totalBlockTimeMinutes: 55,
    billableTimeMinutes: 60,
    discountPercentage: 10,
    costs: { base: 1250, landingFees: 95, handlingFees: 135, navigationFees: 45, taxes: 100, meetAndAssist: 0, lounge: 0, waiting: 0, discount: 125 },
    totalUSD: 1500,
    status: 'APPROVED',
    requiredApprovals: [],
    createdBy: 'USR-001'
  },
  {
    id: 'Q-2026-002',
    customerId: 'CUST-002',
    customerName: 'Coastal Travels',
    date: '2026-01-12',
    productMode: 'SCHEDULED',
    aircraftId: 'C208-2',
    tailNumber: '5H-AZH',
    legs: [
      { id: 'SL1', from: 'ARK', to: 'ZNZ', paxPick: 6, paxOB: 6, paxDrop: 6, paxCount: 6, isDeadLeg: false, distance: 400, blockTimeMinutes: 90, etd: '09:30', eta: '11:00', tacticalStatus: 'OPEN', assignedCrew: ['PILOT-3'] }
    ],
    totalBlockTimeMinutes: 90,
    billableTimeMinutes: 90,
    discountPercentage: 0,
    costs: { base: 2700, landingFees: 110, handlingFees: 160, navigationFees: 55, taxes: 210, meetAndAssist: 300, lounge: 450, waiting: 0, discount: 0 },
    totalUSD: 3985,
    status: 'APPROVED',
    requiredApprovals: [],
    createdBy: 'USR-001'
  },
  {
    id: 'Q-2026-003',
    customerId: 'CUST-001',
    customerName: 'Serengeti Safaris',
    date: '2026-01-12',
    productMode: 'CHARTER',
    aircraftId: 'UNASSIGNED',
    legs: [
      { id: 'UL1', from: 'SEU', to: 'MWB', paxPick: 2, paxOB: 2, paxDrop: 2, paxCount: 2, isDeadLeg: false, distance: 60, blockTimeMinutes: 35, etd: '11:30', eta: '12:05', tacticalStatus: 'OPEN' }
    ],
    totalBlockTimeMinutes: 35,
    billableTimeMinutes: 60,
    discountPercentage: 0,
    costs: { base: 1250, landingFees: 120, handlingFees: 150, navigationFees: 60, taxes: 40, meetAndAssist: 0, lounge: 0, waiting: 0, discount: 0 },
    totalUSD: 1620,
    status: 'SENT',
    requiredApprovals: [],
    createdBy: 'USR-001'
  }
];

export const MOCK_BOOKINGS: Booking[] = [
  {
    id: 'B-001',
    customerId: 'CUST-001',
    customerName: 'Serengeti Safaris',
    date: '2026-01-12',
    paxCount: 2,
    from: 'SEU',
    to: 'MWB',
  }
];
